import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import "./style.css";
import { getStudents } from "../../services/auth";
import StudentWalletSummary from "./components";

const StudentTransactions = () => {
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [students, setStudents] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    // Set flag to show the transactions component
    setShowTransactions(true);
  };

  const handleChange = (e) => {
    const studentId = e.target.value;
    setSelectedStudentId(studentId);
    setShowTransactions(false);

    if (studentId) {
      const selectedStudent = students.find(
        (student) => student.id === studentId
      );
      if (selectedStudent) {
        setDisplayName(selectedStudent.fullName);
      }
    } else {
      setDisplayName("");
    }
  };

  const fetchStudents = async () => {
    try {
      const { data } = await getStudents();
      setStudents(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  return (
    <Layout>
      <div className="container mt-4">
        <div className="row text-center w-100 mb-2">
          <h3 className="h3">
            {displayName
              ? `Search Results for "${displayName}"`
              : "Search transaction of Students"}
          </h3>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <form onSubmit={handleSearch} className="search-form">
              <div className="input-group">
                <select
                  className="form-select search-select"
                  value={selectedStudentId}
                  onChange={handleChange}
                  aria-label="Search"
                >
                  <option value="">Select a student...</option>
                  {students?.map((student) => (
                    <option key={student?.id} value={student?.id}>
                      {student?.fullName}
                    </option>
                  ))}
                </select>
                <button
                  className="btn btn-dark search-button"
                  type="submit"
                  disabled={!selectedStudentId}
                >
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>

        {showTransactions && selectedStudentId && (
          <div className="row mt-4">
            <div className="col-12">
              <StudentWalletSummary id={selectedStudentId} />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default StudentTransactions;
